import api from "../../../api/axios";

const VAGOES_BASE = "/bases_estaleiro/vagoes";

export async function listarVagoesEstaleiro({ q = "", ativo, limit = 100, offset = 0 } = {}) {
  const { data } = await api.get(`${VAGOES_BASE}/listar`, {
    params: { q, ativo, limit, offset },
  });
  return Array.isArray(data?.data) ? data.data : [];
}

export async function contarVagoesEstaleiro({ q = "", ativo } = {}) {
  const { data } = await api.get(`${VAGOES_BASE}/total`, {
    params: { q, ativo },
  });
  return Number(data?.total || 0);
}

export async function resumirVagoesEstaleiro({ q = "" } = {}) {
  try {
    const { data } = await api.get(`${VAGOES_BASE}/resumo`, {
      params: { q },
    });

    const totalRaw = data?.data?.total ?? data?.total ?? 0;
    const ativosRaw = data?.data?.ativos ?? data?.ativos ?? 0;
    const inativosRaw = data?.data?.inativos ?? data?.inativos ?? 0;

    return {
      total: Number(totalRaw || 0),
      ativos: Number(ativosRaw || 0),
      inativos: Number(inativosRaw || 0),
    };
  } catch {
    const [total, ativos, inativos] = await Promise.all([
      contarVagoesEstaleiro({ q }),
      contarVagoesEstaleiro({ q, ativo: 1 }),
      contarVagoesEstaleiro({ q, ativo: 0 }),
    ]);
    return { total, ativos, inativos };
  }
}

export async function cadastrarVagaoEstaleiro({ serieVagao, codigoVagao }) {
  const { data } = await api.post(`${VAGOES_BASE}/cadastrar`, {
    serie_vagao: serieVagao,
    codigo_vagao: codigoVagao,
    ativo: 1,
  });
  return data?.data || null;
}

export async function editarVagaoEstaleiro(id, { serieVagao, codigoVagao }) {
  const { data } = await api.put(`${VAGOES_BASE}/editar/${id}`, {
    serie_vagao: serieVagao,
    codigo_vagao: codigoVagao,
  });
  return data?.data || null;
}

export async function alterarStatusVagaoEstaleiro(id, ativo) {
  const { data } = await api.patch(`${VAGOES_BASE}/alterar-ativo/${id}`, {
    ativo: Number(ativo) ? 1 : 0,
  });
  return data?.data || null;
}

export async function excluirVagaoEstaleiro(id) {
  const { data } = await api.delete(`${VAGOES_BASE}/excluir/${id}`);
  return data?.data || null;
}
